/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Manager_Permissions_Update_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to update permissions: {error}" |
*
* @param {Knp_Manager_Permissions_Update_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_permissions_update_failed = /** @type {((inputs: Knp_Manager_Permissions_Update_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Permissions_Update_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de la mise à jour des autorisations : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Berechtigungen konnten nicht aktualisiert werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile aggiornare le autorizzazioni: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось обновить права доступа: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al actualizar los permisos: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`更新权限失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`権限の更新に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अनुमतियों को अपडेट करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao atualizar as permissões: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to update permissions: ${i?.error}`)
});